import { useQuery } from "@apollo/client/react";
import { MySharedItemsDocument } from "@/graphql/generated/operations";
import { sortOrderFor } from "@/lib/share-sort";

// The signed-in user's own shared items as the Home and Share landing pages show them: one page of
// twenty, newest first. Without `order` genesis pages by primary key ascending (a time-ordered
// UUIDv7, so oldest first) and `first` cuts off the newest (spark#945); "new" is the order the full
// list (/share/mine) opens with. Defined once so both pages send identical variables and the second
// one renders straight from the Apollo cache before the cache-and-network refresh (spark#1010).
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const MY_SHARED_ITEMS_INPUT: any = { first: 20, where: { owner: { eq: true } }, order: sortOrderFor("new") };

export function useMySharedItems() {
  const { data, loading, error } = useQuery(MySharedItemsDocument, {
    variables: { input: MY_SHARED_ITEMS_INPUT },
  });
  return {
    items: data?.sharedItems?.nodes ?? [],
    // null while loading or after a failure: a caller must not read that as "none yet" (spark#1007).
    total: data?.sharedItems?.totalCount ?? null,
    loading,
    error,
  };
}
